import { render, staticRenderFns } from "./main-saksi.vue?vue&type=template&id=38520dda&"
import script from "./main-saksi.vue?vue&type=script&lang=js&"
export * from "./main-saksi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "main-saksi.vue"
export default component.exports